import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Resource } from 'src/app/models/resource.model';
import { Img } from 'src/app/models';
import { ResourceService } from 'src/app/services/resource.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ConfirmationDialogComponent } from '../../shared/index';

@Component({
  selector: 'my-rep-resource-form',
  templateUrl: './resource-form.component.html',
  styleUrls: ['./resource-form.component.scss'],
})
export class ResourceFormComponent implements OnInit {
  public resourceFormGroup: FormGroup;
  public isLoading: boolean = false;
  public isEditMode: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<ResourceFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Resource,
    private snackbarService: SnackbarService,
    private resourceService: ResourceService,
    private dialog: MatDialog
  ) {}

  public ngOnInit(): void {
    this.isEditMode = !!this.data?._id;
    this.resourceFormGroup = new FormGroup({
      _id: new FormControl(this.data?._id || ''),
      type: new FormControl(this.data?.type || 'hospital', [
        Validators.required,
      ]),
      name: new FormControl(this.data?.name || '', [Validators.required]),
      contactNumber: new FormControl(this.data?.contactNumber || ''),
      address: new FormControl(this.data?.address || ''),
      city: new FormControl(this.data?.city || ''),
      postalCode: new FormControl(this.data?.postalCode || ''),
      logo: new FormControl(this.data?.logo || null),
    });
  }

  public get logoImage(): Img {
    const logo = this.resourceFormGroup.get('logo').value;
    return logo ? { location: logo } : null;
  }

  public imageUploaded(img: Img): void {
    this.resourceFormGroup.patchValue({ logo: img.location });
  }

  public imageRemoved(): void {
    this.resourceFormGroup.patchValue({ logo: null });
  }

  public submit(): void {
    if (this.resourceFormGroup.invalid) {
      this.resourceFormGroup.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    const value = this.resourceFormGroup.value;
    const payload: Partial<Resource> = {
      name: value.name.trim(),
      type: value.type,
      contactNumber: value.contactNumber,
    };
    if (value.type === 'hospital') {
      payload.address = value.address;
      payload.city = value.city;
      payload.postalCode = value.postalCode;
      payload.logo = null;
    } else {
      payload.logo = value.logo;
    }

    const request = this.isEditMode
      ? this.resourceService.updateResource(this.data._id, payload)
      : this.resourceService.createResource(payload);

    request.subscribe(
      () => {
        this.isLoading = false;
        this.dialogRef.close(true);
        this.dialog.open(ConfirmationDialogComponent, {
          width: '40rem',
          autoFocus: false,
          data: {
            icon: 'tick',
            title: this.isEditMode ? 'Resource Updated' : 'Resource Added',
            message: this.isEditMode
              ? 'The resource has been updated successfully!'
              : 'New resource has been added successfully!',
          },
        });
      },
      (err) => {
        this.snackbarService.openSnackBar(err.error.message, 'Close');
        this.isLoading = false;
      }
    );
  }

  public cancelForm(): void {
    this.dialogRef.close();
  }
}
